export default class TopNav {
  constructor() {
    const navBar = document.getElementById('header');
    // const primaryLogo = document.querySelector('.primary-logo');
    // const secondaryLogo = document.querySelector('.secondary-logo');
    const visual = document.querySelector('.bnr');
    const visualContent = document.querySelector('.bnr-inner');
    const logo = document.querySelector('.logo');

    if (visual) {
      window.addEventListener('scroll', () => {
        const docViewTop = document.documentElement.scrollTop;
        visualContent.style.opacity = Math.max(0, Math.min(1, -docViewTop / 130 + 2));

        if (visual.clientHeight <= docViewTop) {
          navBar.classList.add('header-hidden');
          navBar.classList.add('header-fixed');
          navBar.classList.add('header-visible');
          logo.style.backgroundImage = `url(${logo.dataset.secondaryLogo})`;
        } else {
          navBar.classList.remove('header-hidden');
          navBar.classList.remove('header-fixed');
          navBar.classList.remove('header-visible');
          logo.style.backgroundImage = `url(${logo.dataset.mainLogo})`;
        }
      });
    }
  }
}
